// src/icons/PythonTwoTone.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function PythonTwoTone() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.2783 -0.199511C11.2995 -0.194963 10.3647 -0.111484 9.54227 0.0340522C7.11937 0.4621 6.67946 1.35804 6.67946 3.01031V5.19246H12.4051V5.91984H6.67946H4.53069C2.86667 5.91984 1.4096 6.92001 0.95385 8.82269C0.428147 11.0036 0.404829 12.3645 0.95385 14.6417C1.36085 16.3368 2.33281 17.5446 3.99683 17.5446H5.96543V14.9287C5.96543 13.0389 7.60056 11.3719 9.54227 11.3719H15.2612C16.8532 11.3719 18.124 10.0611 18.124 8.46234V3.01031C18.124 1.45863 16.815 0.293021 15.2612 0.0340522C14.2776 -0.129677 13.2571 -0.204059 12.2783 -0.199511ZM9.18191 1.55555C9.77333 1.55555 10.2563 2.04641 10.2563 2.64996C10.2563 3.25137 9.77333 3.73769 9.18191 3.73769C8.58838 3.73769 8.10753 3.25137 8.10753 2.64996C8.10753 2.04641 8.58838 1.55555 9.18191 1.55555Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18.8383 5.91992V8.46242C18.8383 10.4336 17.1671 12.0927 15.2614 12.0927H9.54249C7.97598 12.0927 6.67969 13.4334 6.67969 15.0022V20.4542C6.67969 22.0059 8.02898 22.9186 9.54249 23.3637C11.3549 23.8967 13.0929 23.993 15.2614 23.3637C16.7029 22.9464 18.1242 22.1065 18.1242 20.4542V18.2721H12.4053V17.5447H18.1242H20.987C22.6511 17.5447 23.2711 16.384 23.8498 14.6418C24.4476 12.8483 24.4222 11.1235 23.8498 8.82277C23.4386 7.16623 22.6532 5.91992 20.987 5.91992H18.8383ZM15.6218 19.7268C16.2153 19.7268 16.6962 20.2132 16.6962 20.8146C16.6962 21.4181 16.2153 21.909 15.6218 21.909C15.0304 21.909 14.5474 21.4181 14.5474 20.8146C14.5474 20.2132 15.0304 19.7268 15.6218 19.7268Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

export {
  PythonTwoTone
};
